import {type VariantProps} from 'class-variance-authority';
import {Slot} from 'radix-ui';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {iconButtonVariants} from './icon-button-variants';

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof iconButtonVariants> {
  asChild?: boolean;
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({className, variant, size, asChild = false, children, ...props}, ref) => {
    if (asChild) {
      return (
        <Slot.Slot
          className={cn(iconButtonVariants({variant, size}), className)}
          ref={ref}
          {...props}
        >
          {children}
        </Slot.Slot>
      );
    }

    return (
      <button
        className={cn(iconButtonVariants({variant, size}), className)}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);
IconButton.displayName = 'IconButton';

export {IconButton};
